module.exports = __webpack_public_path__ + "img/festa_202503.60505cb6.png";